import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-login-page',
  templateUrl: './mobile-login-page.component.html',
  styleUrls: ['./mobile-login-page.component.scss']
})
export class MobileLoginPageComponent implements OnInit {

  constructor(private router:Router
  ) { }

  ngOnInit(): void {}

}
